import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'pagination-modal',
  styleUrls: ['./pagination-modal.component.less'],
  templateUrl: './pagination-modal.component.html',
  standalone: false
})
export class PaginationModalComponent {
  @Input() max: number;
  @Input() min: number;
  @Input() current: number;
  @Output() pageChange = new EventEmitter<number>()
  invalidPageError: boolean = false

  save(event) {
    if(this.current < this.min || this.current > this.max) {
      this.invalidPageError = true;
      event.stopPropagation();
    } else {
      this.pageChange.emit(this.current);
    }
  }
}
